(function () {
    // let requestUrl = 'http://cg.cwwjiaoyu.cn'; // 本地测试测试服务器环境
   // let requestUrl = 'http://cg.cwwjiaoyu.cn'; // 本地测试线上服务器环境
    let requestUrl = window.location.origin; // 线上环境（自动获取origin）
    localStorage.setItem('cww_url', requestUrl);
})();
